import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import type { ReactNode } from "react";

interface AuthGuardProps {
  children: ReactNode;
  requiredRole?: "client" | "hacker" | "admin";
}

export default function AuthGuard({ children, requiredRole }: AuthGuardProps) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#161b22]">
        <div className="text-center">
          <i className="fas fa-spinner fa-spin text-3xl text-[#5bc0de] mb-3 block" />
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("open-auth-modal", { detail: { mode: "login" } }));
    }, 200);
    return <Navigate to="/" replace />;
  }

  if (requiredRole && profile?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}